import { getQueryParams } from 'src/helpers/rest';
import moEngageUtils from './moengage';

export const initAnalytics = () => {
    // Initialize MoEngage
    moEngageUtils?.initializeMoEngage();
}

const trackMoEngageEvent = (eventName: string, eventData: any) => {
    moEngageUtils?.trackEvent(eventName, eventData);
}

export const trackEvent = (eventName = '', eventData: any = {}) => {
    try {
        const data: any = { ...eventData };
        if (eventData?.utm) {
            const queryParams = getQueryParams(eventData?.search || '');
            data['utm_source'] = queryParams['utm_source'] || null;
            data['utm_medium'] = queryParams['utm_medium'] || null;
            data['utm_campaign'] = queryParams['utm_campaign'] || null;
        }
        delete data.utm;
        delete data.search;
        trackMoEngageEvent(eventName, data);
    } catch (error) {
        console.error('Error tracking event:', error);
    }
}

export const analytics = {
    setUserProperties: (user: any) => moEngageUtils?.setUserAttributes(user),
    logout: () => moEngageUtils?.logout(),
}
